import { StockItem } from 'search-gateway-client';
import { v4 } from 'uuid';

import { ClickLabel } from '@videoblocks/events-ts/lib/storyblocks/content/ClickLabelEnum';
import { StockItemClickEvent } from '@videoblocks/events-ts/lib/storyblocks/content/StockItemClickEvent';
import { Origin } from '@videoblocks/events-ts/lib/storyblocks/navigation/OriginEnum';

import { CommonRecordFactory } from '../shared/CommonRecordFactory';
import parseDevice from '../shared/parseDevice';
import searchIdentifiers from '../shared/searchIdentifiers';
import ShallowStockItemFactory from './ShallowStockItemFactory';

export type StockItemClickEventFactoryOptions = {
    stockItem: StockItem;
    position?: number;
    clickLabel: keyof typeof ClickLabel | null;
    visitorCookieId: string | null;
    headers: Headers;
    currentUrl: URL;
    referrer: URL | undefined;
    searchIdCookie: string | null;
    searchPageIdCookie: string | null;
    sessionToken: string | undefined;
};

async function create(options: StockItemClickEventFactoryOptions): Promise<StockItemClickEvent> {
    const {
        stockItem,
        position = 0,
        clickLabel,
        visitorCookieId,
        headers,
        currentUrl,
        referrer,
        searchIdCookie,
        searchPageIdCookie,
        sessionToken,
    } = options;

    const referrerUrl = referrer?.href;

    const event = new StockItemClickEvent();
    event.meta = {
        uuid: v4(),
        emitted: Date.now(),
        origin: Origin.STORYBLOCKS_NEXTJS,
        trace: null, // todo: this is set in PageViewEventFactory, needed here?
    };
    event.user = await CommonRecordFactory.user(sessionToken, visitorCookieId);
    event.urls = { currentUrl: currentUrl.href, referrerUrl };
    event.device = parseDevice(headers, referrerUrl);
    event.searchIdentifiers = searchIdentifiers(searchIdCookie, searchPageIdCookie);
    event.label = clickLabel as ClickLabel;
    event.stockItem = ShallowStockItemFactory.create(stockItem);
    event.position = position;

    return event;
}

export const StockItemClickEventFactory = { create };
